import Form from "@ant-design/compatible/es/form";
import FormCard from "@impero-com/common/components/formCard";
import FormCardContainer from "@impero-com/common/components/formCardContainer";
import RightSideIcon from "@impero-com/common/components/rightSideIcon";
import { t } from "@impero-com/common/utils/i18n";
import { Button, CardFooter, FormTitle, FormSubtitle } from "@impero-com/ui";
import { Trans } from "react-i18next";
import { Link, useSearchParams } from "react-router-dom";

import emailSent from "img/email-sent.svg";

const FormItem = Form.Item;

export default function CheckInbox() {
    const [searchParams] = useSearchParams();
    const email = searchParams.get("email") ?? undefined;

    return (
        <FormCardContainer
            rightSide={<RightSideIcon icon={emailSent} customImages={false} />}
        >
            <FormTitle title={t("LoginFlow_CheckYourInbox")} />
            <FormSubtitle subtitle="">
                <Trans i18nKey="LoginFlow_EmailSentWithLink" values={{ email }}>
                    We have sent an email to <a>{email}</a> with a link to get
                    you back to your organization
                </Trans>
            </FormSubtitle>
            <FormCard>
                <FormItem>
                    <Link to="/forgot">
                        <Button
                            id="loginFormSubmitBtn"
                            variant="primary"
                            type="submit"
                            block
                        >
                            {t("LoginFlow_WrongEmail")}
                        </Button>
                    </Link>
                </FormItem>
            </FormCard>

            <CardFooter />
        </FormCardContainer>
    );
}
